import { INDIVIDUAL } from '@/const/license';

export const getLicenseTypeValue = (licenseType: EnumPresenter | undefined | null, descriptionOfMaxTons: number) => {
  if (licenseType?.code === INDIVIDUAL) {
    return `개인개별 (1.5톤 이상 ~ ${descriptionOfMaxTons}톤)`;
  }
  return licenseType?.desc || '';
};
